import { createFileRoute } from "@tanstack/react-router";

import { AttioFormPage } from "~/pages/connection-new/attio-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/attio",
)({
  component: AttioFormPage,
});
